import React from 'react'
import Rating from 'react-rating';

export default function DisplayInfo(props) {

  let ratingCount = 0;
  if(props.ratingCount)
  {
    ratingCount = props.ratingCount;

    if(props.ratingCount > 1000) {
      ratingCount = `${(props.ratingCount / 1000).toFixed(1)}k`;
    }
  }

  let sellCount = 0;
  if(props.sellCount)
  {
    sellCount = props.sellCount;
    if(props.sellCount > 1000) {
      sellCount = `${(props.sellCount / 1000).toFixed(1)}k`;
    }
  }


  return (
    <div className='display-info-container'>
        <div className='info-section rating'>
          <div className='display-number rating-number'>{props.rating.toFixed(2)}</div>
          <Rating
            emptySymbol="far fa-star rating"
            fullSymbol="fa fa-star rating"
            initialRating={props.rating}
            readonly
          />
        </div>
        <div className='info-section rating-count'>
          <div className='display-number'>{ratingCount}</div>vote
        </div>
        <div className='info-section sell-count'>
          <div className='display-number'>{sellCount}</div>đã bán
        </div>
    </div>
  )
}
